import {AutocompleteRenderInputParams, TextField} from '@mui/material';
import {getRequiredAdornment} from '../../../utils/functions/getRequiredAdornment';

type AutocompleteRenderInputProps = {
    params: AutocompleteRenderInputParams;
    value: unknown;
    required?: boolean;
    label?: string;
};

export const AutocompleteRenderInput = ({
    params,
    value,
    required = false,
    label,
}: AutocompleteRenderInputProps) => {
    const additionalProps = getRequiredAdornment({value, required});
    return (
        <TextField
            {...params}
            label={label}
            variant='standard'
            InputProps={{
                ...params.InputProps,
                ...additionalProps,
            }}
        />
    );
};
